/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_SsoProvider_LandingPageOptionDto } from '../models/Wealthlane_Dtos_SsoProvider_LandingPageOptionDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LandingPageService {

    /**
     * @returns Wealthlane_Dtos_SsoProvider_LandingPageOptionDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppLandingPageLandingPageOptions(): CancelablePromise<Array<Wealthlane_Dtos_SsoProvider_LandingPageOptionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/landing-page/landing-page-options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
